import { FC } from 'react';
import { DrugItem } from 'src/api/types';
import cn from 'classnames';
import { GTAGPrefix } from 'src/hooks/useGTAG';
import DrugsCarousel from './DrugsCarousel';
import SkeletonLoaders from '../Loaders/SkeletonLoaders';

interface Props {
  isLoading: boolean;
  drugsList?: DrugItem[];
  gtagPrefix: GTAGPrefix;
  addToCartGAAction?: string;
  clickOnCardGAAction?: string;
}

const DesktopDrugList: FC<Props> = ({
  isLoading,
  drugsList,
  gtagPrefix,
  addToCartGAAction,
  clickOnCardGAAction
}) => {
  return (
    <div className="w-full">
      <div
        className={cn(
          'flex w-full pt-[63px] space-between',
          !isLoading && 'hidden'
        )}
      >
        <SkeletonLoaders
          loaderList={[
            { height: 379, width: 238 },
            { height: 379, width: 238 },
            { height: 379, width: 238 },
            { height: 379, width: 238 },
            { height: 379, width: 238 }
          ]}
        />
      </div>
      <DrugsCarousel
        data={drugsList}
        gtagPrefix={gtagPrefix}
        addToCartGAAction={addToCartGAAction}
        clickOnCardGAAction={clickOnCardGAAction}
        className={cn({ hidden: isLoading })}
      />
    </div>
  );
};

export default DesktopDrugList;
